import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Home } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';

const ApplicationSuccessPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--bg-cream)' }}>
      <Card className="premium-card max-w-2xl mx-4 p-12 text-center">
        <div className="flex justify-center mb-8">
          <div className="w-24 h-24 rounded-full flex items-center justify-center" style={{ background: 'linear-gradient(135deg, var(--accent-teal) 0%, var(--accent-gold) 100%)' }}>
            <CheckCircle className="w-12 h-12 text-white" />
          </div>
        </div>
        
        <h1 className="heading-lg mb-6">Application Submitted Successfully!</h1>
        
        <p className="body-lg mb-8" style={{ color: 'var(--text-grey)' }}>
          Thank you for your interest in joining Winhouse Tutors. We've received your application and will review it within <strong>3-5 business days</strong>.
        </p>
        
        <div className="mb-8 p-6 rounded-lg" style={{ background: 'var(--bg-cream)' }}>
          <h3 className="heading-sm mb-4">What Happens Next?</h3>
          <ul className="text-left space-y-3">
            <li className="flex items-start gap-3">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: 'var(--accent-teal)' }} />
              <span className="body-md" style={{ color: 'var(--text-grey)' }}>Our team will review your application and qualifications</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: 'var(--accent-teal)' }} />
              <span className="body-md" style={{ color: 'var(--text-grey)' }}>Shortlisted candidates will be contacted for an interview</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: 'var(--accent-teal)' }} />
              <span className="body-md" style={{ color: 'var(--text-grey)' }}>You'll receive an email update about your application status</span>
            </li>
          </ul>
        </div>
        
        <Button onClick={() => navigate('/')} className="btn-primary">
          <Home className="w-5 h-5" />
          Return to Homepage
        </Button>
      </Card>
    </div>
  );
};

export default ApplicationSuccessPage;
